class MFRFooter {
  constructor( i, e ) {
    this.$index = i;
    this.$element = $( e );

    this.selectors = {
      menus: ".footer__menus",
      title: ".footer__menu-title",
      sunEye: ".footer__sun-eye"
    };

    this.init();
  }

  init() {
    // this.$menus = this.$element.find( this.selectors.menus );
    // this.$title = this.$element.find( this.selectors.title );
    // this.$eye = this.$element.find( this.selectors.sunEye );

    // window.onWidthResize( this.toggleAccordion.bind( this ) );
    // this.toggleAccordion();

    // $( "body" ).on( "mousemove", this.__handleMouseMove.bind( this ) );
  }

  __handleMouseMove( e ) {
    let rawPercentagePosition = (e.originalEvent.x / $( window ).width() * 100).toFixed(2);
    let percentagePosition = (50 * rawPercentagePosition / 100) + 25;
    this.$eye.css( "--left-position", `${ percentagePosition }%` );
  }

  toggleAccordion() {
    if( !Foundation ) return;

    if( $( window ).width() <= 1023 ) {
      Foundation.reInit(this.$menus, "accordion");
      this.$title.removeAttr("tabindex");
    }
    else {
      this.$menus.foundation("_destroy");
      this.$title.attr( "tabindex", "-1" );
    }
  }
}


